import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Route } from "react-router-dom";
import { createStore } from "redux";
import Echo from "laravel-echo";
import "react-datepicker/dist/react-datepicker.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Pusher from "pusher-js";
import { composeWithDevTools } from "redux-devtools-extension";
import "react-notifications/lib/notifications.css";
import "nprogress/nprogress.css";
import "react-table/react-table.css";

// relative imports
import { rootReducer } from "./RootReducer";
import { loginAction } from "./actions/UserActions";
import { newNotification, getNotifications, } from "./actions/NotificationActions";
import BaseRoute from "./components/routes/BaseRoute";
import registerServiceWorker from "./registerServiceWorker";
import "./assets/fonts/MaterialIcons/material-icons.css";
import "./styles/main.scss";

export const store = createStore( rootReducer, composeWithDevTools() ); // eslint-disable-line  import/prefer-default-export

if (localStorage.loggedInUserData) {
	store.dispatch(loginAction(JSON.parse(localStorage.loggedInUserData)));

	// const notificationListener = new Echo({
	// 	broadcaster: "pusher",
	// 	key: "44e4ebe41d15059e1be0",
	// 	cluster: "eu",
	// 	encrypted: true
	// });

	// notificationListener.channel("my-channel").listen(".my-event", (new_notification) => {	
	// 	store.dispatch(newNotification(new_notification));				
	// 	console.log("New notification", store.getState());
	// });
}

// axios.get("https://jsonplaceholder.typicode.com/albums").then((response) => {
// 	store.dispatch(getNotifications2(response.data));
// }).catch((error) => {
// 	console.log("error fetching notifications",error);
// });
// store.subscribe(() => {
// 	console.log("Subscription", store.getState());
// });

ReactDOM.render(
	<BrowserRouter>
		<Provider store={store}>
			<Route component={BaseRoute} />
		</Provider>
	</BrowserRouter>,
	document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js